import { validate as uuidValidate } from 'uuid';

import { BASKET_ID_PARAM } from '@constants/queryParams';

const getBasketIdFromUrl = () => {
  const idFromUrl = new URLSearchParams(window.location.search).get(
    BASKET_ID_PARAM
  );

  if (!idFromUrl || !uuidValidate(idFromUrl)) {
    return null;
  }

  return idFromUrl;
};

export { getBasketIdFromUrl };
